import { DataTable } from "../../../components/common/datatable/DataTable";
import { useGetTeamAndUserAssignmentsQuery } from "../../order/productsApi";
import { useState } from "react";
import { useFindUserSettingsByGroupNameQuery } from "../../../components/common/userSetting/userSettingsApi";
import { hasPermission } from "../../../helpers/utils/AccessControlUtils";
import { createClickableLink } from "../../../components/common/datatable/DataTableUtils";
import { formatValueAsDate, formatValueAsDateAndTime } from "../../../helpers/utils/DateUtils";
import { DataTableColumn } from "../../../components/common/datatable/DataTableTypes";
import { getProductStatusDotInfo, getShortProductName } from "../../../helpers/utils/Utils";
import AddFollowUpForProduct from "../../order/modal/AddFollowUpForProduct";

const TeamWorkTab = () => {

    const { data: userSettings } = useFindUserSettingsByGroupNameQuery("Team Work");
    const [curProduct, setCurProduct] = useState({});
    const [orderId, setOrderId] = useState("");
    const [showFollowUpModal, setShowFollowUpModal] = useState(false);

    const columns: DataTableColumn[] = [
        {
            label: "Order No.",
            accessor: "customerOrderNumber",
            cell: (props: any) => {
                let path = `/orders/${props.row.original.orderId}`;
                return createClickableLink(path, props.value, userSettings, false, "", ["ORDR-R", "ORDR-V"]);
            },
            canSort: false,
        },
        {
            label: "Customer",
            accessor: "customerId",
            canSort: false,
        },

        {
            label: "County",
            accessor: "county",
            canSort: false,
        },
        {
            label: "Address",
            accessor: "addressLine1",
            canSort: false,
        },
        {
            label: "Product", accessor: "type", canSort: false, cell: (props: any) => {
                return (<>
                    <div className={props.row.original.followUpTypeDTO == null ? "product-div" : undefined}>

                        {hasPermission(["PROFOLLUP-V"]) && props.row.original.followUp != null &&
                            <i className={hasPermission(["PROFOLLUP-R"]) ? "fa fa-solid fa-tag mr-1 cursor-pointer" : "fa fa-solid fa-tag mr-1"}
                                onClick={(e) => {
                                    if (hasPermission(["PROFOLLUP-R"])) {
                                        e.preventDefault();
                                        setCurProduct(
                                            {
                                                id: props.row.original.productId,
                                                followUp: props.row.original.followUp,
                                                followUpTypeDTO:props.row.original.followUpTypeDTO,
                                            }
                                        );
                                        setOrderId(props.row.original.orderId);
                                        setShowFollowUpModal(true);
                                    }
                                }}
                                title={props.row.original.followUpTypeDTO != null
                                    ? props.row.original.followUpTypeDTO.name + ' : ' + formatValueAsDate(props.row.original.followUp.followUpAdded, "MM/DD/YY") + " " + props.row.original.followUp.followUpMessage
                                    : undefined}

                                style={{ color: props.row.original.followUpTypeDTO != null ? props.row.original.followUpTypeDTO.hexColor : '' }} />
                        }

                        {props.row.original.assignedTo !== null ?

                            <i title={props.row.original.assignedTo + " (" + getProductStatusDotInfo(props.row.original.productStatus).title + ")"}
                                className="fa fa-user mr-1 default-cursor"
                                style={{ color: getProductStatusDotInfo(props.row.original.productStatus).color }} /> :
                            <i className="product_status_circle fa fa-solid fa-circle mr-1 default-cursor"
                                style={{ color: getProductStatusDotInfo(props.row.original.productStatus).color }}
                                title={getProductStatusDotInfo(props.row.original.productStatus).title}
                            />

                        }
                        <span>{getShortProductName(props.row.original.type)}</span>
                    </div>
                </>)
            }
        },

        {
            label: "Status", accessor: "productStatus",
        },
        {
            label: <i title="Rush" className="fa fa-clock fa-sm " />, accessor: "rushDate",
            visibility: { hasShowSetting: false },canSort: false,
            cell: (props: any) => <>
                {props.value ? <i title="Rush" className="fa fa-clock fa-sm default-cursor" /> : ''}

            </>

        },
        {
            label: "Assigned Date", accessor: "assignedDate",canSort: false, cell: (props: any) => {
                return formatValueAsDateAndTime(props.row.original.assignedDate);
            }
        },

        {
            label: "Assigned To", accessor: "assignedTo"
        }

    ]

    return (
        <>
            <div className=''>
                <DataTable
                    columns={columns}
                    actions={{
                        fetchAction: useGetTeamAndUserAssignmentsQuery
                    }}
                    defaultFilter={{
                        pageNumber: 0,
                        pageSize: 15,
                        sort:"assignedDate",
                        sortOrder:'desc'
                    }}
                    userSettingGroup='Team Work'
                    defaultSortOptions={{
                        accessor: 'assignedDate',
                        direction: 'desc'
                    }}
                    appendFilterToUrl={false}
                />
            </div>
            {showFollowUpModal && <AddFollowUpForProduct show={showFollowUpModal}
                setShow={setShowFollowUpModal}
                isHoa={false}
                btnName={"Update"}
                currentProduct={curProduct}
                orderId={orderId}
                
            />}
        </>
    )
}
export default TeamWorkTab;